/**
 * @generated SignedSource<<eace5b20d5b43ccb67264b7bfe8421d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type QuestionType = "CHILDREN" | "DATE" | "INPUT" | "MULTI_PUNCH" | "SELECTION";
export type PopQuizBannerQuery$variables = {
  id: string;
};
export type PopQuizBannerQuery$data = {
  readonly node: {
    readonly answerTime?: number | null;
    readonly id?: string;
    readonly possibleAnswers?: {
      readonly answers?: ReadonlyArray<{
        readonly answerKey: string;
        readonly label: string;
      }> | null;
      readonly type: QuestionType;
    } | null;
    readonly responseStatistics?: ReadonlyArray<{
      readonly correct: boolean;
      readonly key: string;
      readonly ratio: number;
      readonly selected: boolean;
    }> | null;
    readonly reward?: {
      readonly formatted: string;
    } | null;
  } | null;
};
export type PopQuizBannerQuery = {
  response: PopQuizBannerQuery$data;
  variables: PopQuizBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answerTime",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "MoneyAmount",
  "kind": "LinkedField",
  "name": "reward",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formatted",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SelectionQuestionAnswer",
    "kind": "LinkedField",
    "name": "answers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "answerKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "SelectionQuestionAnswers",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "MultiPunchQuestionAnswers",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PollResponseStatistic",
  "kind": "LinkedField",
  "name": "responseStatistics",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ratio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correct",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selected",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopQuizBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "possibleAnswers",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "type": "PollQuestion",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopQuizBannerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "possibleAnswers",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "type": "PollQuestion",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f3aa272c8466263038c3667669cab1d",
    "id": null,
    "metadata": {},
    "name": "PopQuizBannerQuery",
    "operationKind": "query",
    "text": "query PopQuizBannerQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on PollQuestion {\n      id\n      answerTime\n      reward {\n        formatted\n      }\n      possibleAnswers {\n        __typename\n        type\n        ... on SelectionQuestionAnswers {\n          answers {\n            answerKey\n            label\n          }\n        }\n        ... on MultiPunchQuestionAnswers {\n          answers {\n            answerKey\n            label\n          }\n        }\n      }\n      responseStatistics {\n        key\n        ratio\n        correct\n        selected\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d021b960712c96efccd8e9aa721a1c0";

export default node;
